var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(255, 255, 255, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(61.092, 188.86, 240.13, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M24,-28.2C31,-22.8,36.3,-15.1,39.1,-5.9C41.9,3.2,42.1,13.8,37.3,21C32.5,28.1,22.7,31.8,13.8,32.8C4.9,33.8,-3.1,32.1,-10.4,29.2C-17.8,26.3,-24.4,22.1,-28.8,16C-33.2,9.8,-35.3,1.6,-34.3,-6.4C-33.3,-14.5,-29.4,-22.3,-23.1,-27.9C-16.9,-33.4,-8.5,-36.6,0,-36.7C8.5,-36.7,17.1,-33.6,24,-28.2Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS02);
export default __webpack_public_path__ + "static/media/s02.14ad6e158a82a9bdd6b521d2aa99d36e.svg";
export { ForwardRef as ReactComponent };